import { TPackageId } from '../../types/api';
import { ITypedReduxAction } from '../../types/redux/actionType';
import { EPaymentInitSource, EProductType } from '../../types/redux/checkout';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export const SET_PAYMENT_CHECKOUT_STATE = 'PAYMENT_WIDGET :: CHECKOUT :: SET_PAYMENT_STATE';

export interface ISetPaymentCheckoutStatePayload {
  isUseBalanceFundsVisible: boolean;
  isUseBalanceFunds: boolean;
  price: number;
  balance: number;
  totalAmount: number;
  paymentAmount: number;
  productType: EProductType;
  paymentInitSource: EPaymentInitSource;
  transactionId: string | undefined;
  packageId: TPackageId;
}

export type TSetPaymentCheckoutStateAction = ITypedReduxAction<
  typeof SET_PAYMENT_CHECKOUT_STATE,
  ISetPaymentCheckoutStatePayload
>;

export const setPaymentCheckoutState: (payload: ISetPaymentCheckoutStatePayload) => TSetPaymentCheckoutStateAction =
  actionGenerator<typeof SET_PAYMENT_CHECKOUT_STATE, ISetPaymentCheckoutStatePayload>(SET_PAYMENT_CHECKOUT_STATE);
